"use client";

import posthog from "posthog-js";
import { useEffect, useRef } from "react";

interface PostHogIdentifyProps {
  readonly properties?: Record<string, string | number | boolean | null>;
  readonly userId: string | null;
}

/**
 *
 */
export function PostHogIdentify({ userId, properties }: PostHogIdentifyProps) {
  const identifiedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!userId || identifiedRef.current === userId) {
      return;
    }

    posthog.identify(userId, properties);
    identifiedRef.current = userId;
  }, [userId, properties]);

  useEffect(() => {
    if (identifiedRef.current && !userId) {
      posthog.reset();
      identifiedRef.current = null;
    }
  }, [userId]);

  return null;
}
